import React from 'react';
import { Check, Clock, PencilLine } from 'lucide-react';
import { Button } from '../ui/button';
import { useLanguage } from '../../contexts/LanguageContext';

export const SummaryStep = ({ savedPlants, onPlantAdded, onEditPlant }) => {
  const { t } = useLanguage();
  return (
    <div className="space-y-4" data-testid="batch-summary">
      <div className="rounded-xl p-5" style={{ backgroundColor: 'hsl(82, 55%, 95%)', border: '1px solid hsl(143, 28%, 85%)' }}>
        <p className="text-sm mb-3" style={{ color: 'hsl(125, 12%, 32%)' }}>
          {t('processedPlants').replace('{count}', savedPlants.length)}
        </p>
        <ul className="space-y-2">
          {savedPlants.map((plant, i) => (
            <li key={i} className="flex items-center gap-2" data-testid={`summary-row-${i}`}>
              {plant.incomplete ? (
                <Clock className="w-4 h-4 flex-shrink-0" style={{ color: 'hsl(21, 70%, 57%)' }} />
              ) : (
                <Check className="w-4 h-4 flex-shrink-0" style={{ color: 'hsl(143, 50%, 45%)' }} />
              )}
              <span className="font-medium min-w-0 truncate" style={{ color: plant.incomplete ? 'hsl(21, 70%, 45%)' : 'hsl(143, 28%, 25%)' }}>
                {plant.common_name}
              </span>
              {plant.incomplete && (
                <span className="text-xs px-2 py-0.5 rounded-full flex-shrink-0" style={{ backgroundColor: 'hsl(21, 70%, 92%)', color: 'hsl(21, 70%, 45%)' }}>
                  {t('incomplete')}
                </span>
              )}
              {plant.scientific_name && !plant.incomplete && (
                <span className="text-sm italic truncate" style={{ color: 'hsl(125, 12%, 32%)' }}>({plant.scientific_name})</span>
              )}
              {onEditPlant && plant.plant_id && (
                <button
                  type="button"
                  onClick={() => onEditPlant(plant.plant_id)}
                  className="ml-auto flex-shrink-0 inline-flex items-center gap-1 text-xs font-medium px-2.5 py-1 rounded-full transition-all hover:shadow-sm"
                  style={{ backgroundColor: 'white', color: 'hsl(143, 28%, 25%)', border: '1px solid hsl(143, 28%, 80%)' }}
                  data-testid={`summary-edit-${i}`}
                >
                  <PencilLine className="w-3 h-3" />
                  {t('edit') || 'Edit'}
                </button>
              )}
            </li>
          ))}
        </ul>
      </div>
      <Button
        onClick={() => onPlantAdded()}
        className="w-full"
        style={{ backgroundColor: 'hsl(143, 28%, 25%)', color: 'hsl(115, 56%, 96%)' }}
        data-testid="summary-ok-button"
      >
        {t('done') || 'OK'}
      </Button>
    </div>
  );
};
